import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import List from '../List';

function SidebarItem(_ref) {
  var active = _ref.active,
      url = _ref.url,
      restProps = _objectWithoutPropertiesLoose(_ref, ["active", "url"]);

  var link = !active && url;

  var listItemProps = _objectSpread({
    alignItems: 'center',
    backgroundColor: 'surfaceTertiary',
    boxShadow: 'inset -8px 0px 8px -8px rgba(150, 150, 150, 0.25)',
    as: link ? 'a' : 'div',
    href: url,
    justifyContent: 'space-between',
    lineHeight: '20px',
    shrink: 0
  }, restProps);

  if (active) {
    listItemProps.backgroundColor = 'surfaceSecondary';
    listItemProps.boxShadow = 'inset 0 -2px var(--colors-primary)';
    listItemProps.zIndex = 1;
  }

  if (link) {
    listItemProps.hover = {
      backgroundColor: 'grey-2'
    };
  }

  return /*#__PURE__*/React.createElement(List.Item, listItemProps);
}

export default SidebarItem;